export const codeConstants = {
  REFRESH_SUCCESS: 'REFRESH_SUCCESS',
  REFRESH_ERROR: 'REFRESH_ERROR',
  REFRESH_REQUEST: 'REFRESH_REQUEST'
};
